define('all/dialog',['jquery', 'all/flushcommunicationbar', 'all/jquery/jquery.bpopup-0.8.0'], function($, flushcommunicationbar) {
	'use strict';

	// script needs a div with id "dialog-loading" existing in the page:

	// class name that has CSS something like { background: url(/img/spinner.gif) center no-repeat }
	var LOADING = 'dialog-loading';
	var DIALOG_CLASS = 'dialog';
	var DIALOG_CLOSE_CLASS = '.dialog-close';
	var LOADING_ID = '#' + LOADING;
	var DIALOG_PATH = '/dialog';

	function showLoader() {
		var $loading = $(LOADING_ID);
		if ($loading.length === 0) {
			$loading = $('<div/>');
			$loading.attr('id', LOADING);
			$(document.body).append($loading);
		}
		$loading.bPopup({
			modalClose : false,
			escClose : false,
			positionStyle : 'fixed',
			fadeSpeed : 0,
			zIndex : 9099
		});
	}

	function hideLoader() {
		$(LOADING_ID).bPopup().close();
	}

    function checkIfLoaderIsVisible(){
        if($(LOADING_ID).is(':visible')){
            return true;
        } else{
            return false;
        }
    }

	// open url with optional POST data. Uses patched jquery.bPopup
	function loadDialog(url, data, onLoad, onCancel, onPreLoad) {
		if ($.isFunction(data)) {
			onCancel = onLoad;
			onLoad = data;
			data = {};
		}
		showLoader();
		var $div = $('<div style="display:none"></div>').appendTo('body');

		return $div.bPopup({
			modalClose: false,
			loadUrl : url,
			loadData : data,
			follow : [ false, false ],
			loadCallback : onPreLoad,
			zIndex : 9100,
			onOpen : function() {
				$div.on('click', DIALOG_CLOSE_CLASS, function() {
					$div.bPopup().cancel();
					flushcommunicationbar.flushCommunicationBar();
				});
			},
			onClose : function() {
				$div.off('click');
				$div.remove();
			},
			onCancel : onCancel
		}, function() {
			if ($.isFunction(onLoad)) {
				onLoad.call($div);
			}
			hideLoader();
		});
	}

	function makeId(id) {
		return DIALOG_CLASS + '-' + id.toLowerCase().replace(/[^\w\d\-_]/g, '-');
	}

	function setId($dialog, id) {
		$dialog.attr('id', makeId(id));
	}

	window.dialog = {
		/**
		 * Open dialog jsp from /[site]/dialog or /shared/dialog with optional data that's available as EL in JSP template
		 *
		 * @param {String} path relative path/name from popup directory, excluding the .jsp suffix
		 * @param {Object} [data={}] optional object with properties that will be available to Expression Language
		 * @param {Function} onLoad to be called after dialog is fully loaded, the enclosing $div is passed as argument
		 * @param {Function} onCancel called when the dialog is closed by the user by buttons or overlay
		 */
		load : function(path, data, onLoad, onCancel) {
			var url = DIALOG_PATH;
			if (path.indexOf('/') !== 0) {
				url += '/';
			}
			url += path;
			var $dialog = loadDialog(url, data, onLoad, onCancel);
			setId($dialog, path);
		},

		/**
		 * Fallback function to make it easier to handle legacy things like the deposit popup
		 *
		 * @param {String} flow open /pp?flow=<flow> in dialog
		 * @param {Object} [data={}] optional object with properties that will be used as POST data to flow
		 * @param {Function} onLoad to be called after dialog is fully loaded, the enclosing $div is passed as argument
		 * @param {Function} onCancel called when the dialog is closed by the user by buttons or overlay
		 * @param {Function} onPreLoad is called before the dialog is fully loaded
		 */
		flow: function (flow, data, onLoad, onCancel, onPreLoad) {
			var url = '/pp?flow=' + flow;
			var $dialog = loadDialog(url, data, onLoad, onCancel, onPreLoad);
			setId($dialog, flow);
		},

		/**
		 * Displays the hidden element(s) which may be a selector or jquery element
		 *
		 * @param element
		 * @param {Function} onLoad to be called after dialog is fully loaded
		 */
		show : function(element, onLoad) {
			var $el = $(element);
			$el.bPopup(onLoad);
		},

		close : function(path) {
			$('#' + makeId(path)).bPopup().close();
		},

		closeFlow : function(flow) {
			$('#' + makeId(flow)).bPopup().close();
		},

		existsFlow : function(flow) {
			var bPopup = $('#' + makeId(flow)).bPopup();
			if(bPopup.data('bPopup')){
				return true;
			} else{
				return false;
			}
		},

		closeAll : function() {
			$('[id^="' + DIALOG_CLASS + '-"]').each(function() {
				$(this).bPopup().close();
			});
		},

		showLoader : function() {
			showLoader();
		},

        hideLoader : function() {
            if (checkIfLoaderIsVisible()){
               hideLoader();
            }
        }
	};

	return window.dialog;
});

